/* ATL is for older non-modern browsers */
export const ENTERKEY: string = 'Enter';
export const ENTERKEY_ATL: string = 'Return';
export const ESCAPE: string = 'Escape';
export const ESCAPE_ATL: string = 'Esc';
export const SPACEBAR: string = ' ';
export const SPACEBAR_ATL: string = 'Spacebar';
export const TAB: string = 'Tab';
export const ARROW_DOWN: string = 'ArrowDown';
export const ARROW_DOWN_ATL: string = 'Down';
export const ARROW_UP: string = 'ArrowUp';
export const ARROW_UP_ATL: string = 'Up';

export type VALID_KEYS =
  | typeof ENTERKEY
  | typeof ENTERKEY_ATL
  | typeof ESCAPE
  | typeof ESCAPE_ATL
  | typeof SPACEBAR
  | typeof SPACEBAR_ATL
  | typeof ARROW_DOWN
  | typeof ARROW_DOWN_ATL
  | typeof ARROW_UP
  | typeof ARROW_UP_ATL
  | typeof TAB;
